import { exportFile, GetItemsProps, useApiService } from "medere-ui-framework";
import { POSType } from "../../interface/interface";

export function usePaymentOrdersService() {
  const { getMethod, postMethod } = useApiService();
  const baseEndpoint = "/api/secured/paymentOrders";

  function getAllPaymentOrders(offSet: number, pageSize: number, params: any): Promise<any[]> {
    return getMethod<any[]>({
      basePath: baseEndpoint,
      endpoint: "/getAllPaymentOrders",
      params: {
        offSet,
        pageSize,
        supplierId: params.supplierId,
        sinceDate: params.sinceDate,
        untilDate: params.untilDate
      }
    });
  }

  function savePaymentOrder(paymentOrder: any): Promise<any> {
    return postMethod({
      basePath: baseEndpoint,
      endpoint: "/savePaymentOrder",
      body: paymentOrder
    });
  }

  async function exportPaymentOrderPDF(paymentOrderId: number): Promise<void> {
    await exportFile(`${baseEndpoint}/exportPaymentOrderEarningsPDF`, null, {
      paymentOrderId,
    }).then((response) => {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ganancias_${paymentOrderId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });

    await exportFile(`${baseEndpoint}/exportPaymentOrderIIBBPDF`, null, {
      paymentOrderId,
    }).then((response) => {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `IIBB_${paymentOrderId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }

  function getAllPosTypes({ filterValue, offSet, pageSize }: GetItemsProps): Promise<POSType> {
    return getMethod<POSType>({
      basePath: baseEndpoint,
      endpoint: "/getAllPosTypes",
      params: {
        inputtext: filterValue,
        offSet,
        pageSize
      }
    });
  }

  return {
    getAllPaymentOrders,
    savePaymentOrder,
    exportPaymentOrderPDF,
    getAllPosTypes
  };
}
